import { useContext } from "react";

import { MRT_Localization_EN } from "material-react-table/locales/en";
import { MRT_Localization_PT_BR } from "material-react-table/locales/pt-BR";
import { MRT_Localization_JA } from "material-react-table/locales/ja";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";

import { LanguageContext } from "@shared/context";

export const ReactTable = (props) => {
	const { language } = useContext(LanguageContext);

	const languageMap = {
		en: MRT_Localization_EN,
		ptb: MRT_Localization_PT_BR,
		jp: MRT_Localization_JA,
	};

	let table = useMaterialReactTable({
		...props,
		localization: languageMap[language],
	});

	return (
		<div className="reactTable">
			<MaterialReactTable table={table} />
		</div>
	);
};
